export class NotifiModel{
    notify:boolean;
    notificationId:number;
    type:string;
    name:string;
    content:string;
    maintenanceNotificationId:number;
}